<template>
  <component
    :is="resolveLayoutVariant"
    :class="`skin-variant--${appSkinVariant} ${homeBgColor} AAAAAAAAAAAA`"
  >
    <transition
      :name="appRouteTransition"
      mode="out-in"
      appear
    >
      <router-view></router-view>
    </transition>
  </component>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { computed } from '@vue/composition-api'
// eslint-disable-next-line import/no-unresolved
import useAppConfig from '@core/@app-config/useAppConfig'
import { useRouter } from '@core/utils'
import { useLayout } from '@core/layouts/composable/useLayout'
import store from '@/store'

// Layouts
import LayoutContentVerticalNav from '@/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'
import LayoutContentHorizontalNav from '@/layouts/variants/content/horizontal-nav/LayoutContentHorizontalNav.vue'
import LayoutBlank from '@/layouts/variants/blank/LayoutBlank.vue'

// Dynamic vh
import useDynamicVh from '@core/utils/useDynamicVh'

export default {
  components: {
    LayoutContentVerticalNav,
    LayoutContentHorizontalNav,
    LayoutBlank,
  },
  mounted() {
    const sessionData = localStorage.getItem('session') || sessionStorage.getItem('session')
    if (sessionData) {
      const sessionDataParsed = JSON.parse(sessionData)
      sessionDataParsed.alreadyLoaded = true
      this.$store.dispatch('session/setSessionData', sessionDataParsed)
    }

    const labSettings = localStorage.getItem('lab_settings') || sessionStorage.getItem('lab_settings')
    if (labSettings) {
      const labSettingsParsed = JSON.parse(labSettings)
      this.$store.dispatch('session/setLabSettings', labSettingsParsed)
    }

    const savedLab = localStorage.getItem('user_lab_profile')
    if (savedLab) {
      try {
        const lab = JSON.parse(savedLab)
        this.$store.commit('session/SET_LABORATORY', lab)
      } catch (e) {
        console.warn('No se pudo parsear user_lab_profile', e)
      }
    }

  },
  setup() {
    const { route } = useRouter()
    const { appContentLayoutNav, appSkinVariant, appRouteTransition } = useAppConfig()

    const { handleBreakpointLayoutSwitch } = useLayout()
    handleBreakpointLayoutSwitch()

    const resolveLayoutVariant = computed(() => {
      if (route.value.meta.layout === 'blank') return 'layout-blank'
      if (route.value.meta.layout === 'content') return `layout-content-${appContentLayoutNav.value}-nav`

      return null
    })

    const homeBgColor = computed(() => {
      if (selectedLab.value && selectedLab.value.laboratory_name === 'Iluminar') return ''
      if (route.value.name === 'home') return 'home-bg-color'

      return ''
    })

    const selectedLab = computed(() => {
      return store.getters['session/selectedLaboratory']()
    })

    useDynamicVh()

    return {
      resolveLayoutVariant,
      appSkinVariant,
      appRouteTransition,
      selectedLab,
      homeBgColor
    }
  },
}
</script>

<style scoped>
.home-bg-color {
  background-color: #070705;
}

.iluminar-bg-color {
  background: url('../src/assets/images/homebg.jpg');
}
</style>
